import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "size", "color", "className", "children", "active", "disabled"];
import React from 'react';
import { LoadingIconGrey } from '../Loading';
import { StyledButton, StyledWrapper } from './IconButton.styled';
export function ButtonIconOnly(props) {
  var icon = props.icon,
    size = props.size,
    color = props.color,
    className = props.className,
    children = props.children,
    active = props.active,
    disabled = props.disabled,
    buttonProps = _objectWithoutProperties(props, _excluded);
  var isDisabled = !!active || !!disabled;
  var CurrentIcon = active ? LoadingIconGrey : icon;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledButton, _extends({
    "aria-label": buttonProps.title,
    disabled: isDisabled,
    active: active
  }, buttonProps), /*#__PURE__*/React.createElement(CurrentIcon, {
    size: size,
    style: {
      padding: Math.round(size / 4),
      position: 'relative'
    },
    color: color
  })));
}